// extracted by mini-css-extract-plugin
export default {"tags":"tags-rX_r"};